import { JsonObject, JsonProperty } from 'json2typescript';

import { ProfessionalPosition } from './professional-position';
import { ProfessionalPositionCategoryInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('ProfessionalPositionCategory')
export class ProfessionalPositionCategory implements ProfessionalPositionCategoryInterface {
    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('Positions', [ProfessionalPosition], true)
    private _positions: ProfessionalPosition[] = undefined;

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get positions(): ProfessionalPosition[] {
        return this._positions;
    }

    set positions(value: ProfessionalPosition[]) {
        this._positions = value;
    }
}
